import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'
import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import { syncFormStoreWithSession } from '@resources/js/components/form/formStoreSync'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import { isDesktop } from '@resources/js/helpers/media'
import Sticky, { STICKY_EVENTS } from '@resources/js/ui/Sticky'
import Modal from '@resources/js/ui/Modal'
import { updateFormInfoView } from '@resources/js/components/form/helpers/updateFormInfoView'
import { WEEK_START_MONDAY } from '@resources/js/components/form/constants/calendarWeekDays'
import { loadFlatpickrLocale } from '@resources/js/components/form/helpers/loadFlatpickrLocale'
import '@resources/js/analytics'
import '@resources/js/events/pages/post/post_3'
import SelectionCriteriaView from '@resources/js/widgets/post/selection-criteria/SelectionCriteriaView'
import handleCalendarFormSubmit from '@resources/js/helpers/handleCalendarFormSubmit'
import generateSearchPageUrl from '@resources/js/helpers/generateSearchPageUrl'

const partnerType = getBcomOrExpediaPartnerType()

initSharedPromotion()

const localeLang = shared.options.language.code || 'en'
const localeConfig = await loadFlatpickrLocale(localeLang)

// map
inViewport('#mapbox', () => {
	const map = new MapView({ zoom: 12 })
	const mapHotelsStore = new MapHotelsStore()
	const data = mapHotelsStore.getData()
	map.addMarkers(data)
	map.fitByCoords(mapHotelsStore.getCoordinates())
})

const isDesktopView = isDesktop()
const DATE_FORMAT = 'MMM DD' //Jun 03

const headerElement = document.querySelector('.js-header')
const heroElement = document.querySelector('.js-hero')

const stickyHeader = new Sticky('.js-header', {
	top: heroElement.offsetHeight,
	toggleClass: 'with-fixed-form',
})

// header form
const headerFormElement = headerElement.querySelector('.js-header-form-wrapper')

if (!isDesktopView) {
	new Modal(headerFormElement, {
		trigger: headerElement.querySelector('.js-show-form-trigger'),
		selectors: {
			close: '.js-close-form',
			content: '.js-header-form',
		},
	})

	stickyHeader.on(STICKY_EVENTS.SCROLL_DOWN, () => updateScrollDownState('add'))

	stickyHeader.on(STICKY_EVENTS.SCROLL_UP, () => updateScrollDownState('remove'))

	// кнопка карти з'являється після хіро
	new Sticky('.js-mob-map-btn', {
		top: heroElement.offsetHeight,
		toggleClass: 'visible',
	})
}

const updateScrollDownState = method => {
	headerElement.classList[method](STICKY_EVENTS.SCROLL_DOWN)
}

const SHARED_LOCALE_CONFIG = {
	locale: {
		...localeConfig,
		...WEEK_START_MONDAY,
	},
}

const mainFormCalendarConfig = {
	showMonths: isDesktopView ? 2 : 1,
	...SHARED_LOCALE_CONFIG,
}

const headerFormCalendarConfig = {
	showMonths: 1,
	...SHARED_LOCALE_CONFIG,
}
// спільний стор для форми
const formsStore = new FormStore()
syncFormStoreWithSession(formsStore)

// main форм
const mainFormElement = document.querySelector('.js-form')
const mainFormView = new FormView(mainFormElement, {
	calendarConfig: mainFormCalendarConfig,
})
const mainFormPresenter = new FormPresenter(mainFormView, formsStore, DATE_FORMAT)

const headerFormView = new FormView(headerFormElement, {
	calendarConfig: headerFormCalendarConfig,
})
const headerFormPresenter = new FormPresenter(
	headerFormView,
	formsStore,
	DATE_FORMAT
)

updateFormInfoView(formsStore.getData())

formsStore.on('change', () => {
	updateFormInfoView(formsStore.getData())
})

const dispatchFormSubmitEvent = ({ url }) => {
	document.dispatchEvent(
		new CustomEvent('custom-form-submit', {
			detail: {
				type: 'calendar-form',
				action: 'open',
				category: 'clickunder',
				partnerUrl: url,
			},
		})
	)
}

const searchBaseUrl = atob(
	document.getElementById('search-redirect-url').textContent
)
const customSelfUrlElements = document.querySelectorAll('[data-custom-self-url]')

const getSearchPageUrl = () => {
	return generateSearchPageUrl({
		baseUrl: searchBaseUrl,
		formData: formsStore.getData(),
	})
}

// кнопки-клікандери (js-clk-open) переводять поточну вкладку на URL з атрибута data-custom-self-url,
// тому оновлюємо значення цього атрибута при кожній зміні дат і гостей у формі.
// URL кодуємо в Base64, щоб він не був видний у розмітці (декодує initLinks)
const updateCustomSelfUrls = () => {
	const encodedUrl = btoa(getSearchPageUrl())

	customSelfUrlElements.forEach(el =>
		el.setAttribute('data-custom-self-url', encodedUrl)
	)
}

updateCustomSelfUrls()

formsStore.on('change', updateCustomSelfUrls)
formsStore.on('child-object-add', updateCustomSelfUrls)
formsStore.on('child-object-remove', updateCustomSelfUrls)

// Тимчасово вимкнено, зараз сабміт відкриває тільки букінг у новій вкладці.
// Повернемо з А/Б тестом
// const openPartnerAndRedirectToSearchPage = partnerUrl => {
// 	window.open(partnerUrl, '_blank')
// 	location.href = getSearchPageUrl()
// }

const handleFormSubmit = formData =>
	handleCalendarFormSubmit({
		partnerType,
		formData,
		customBeforeRedirectCallback: dispatchFormSubmitEvent,
		// customRedirectCallback: openPartnerAndRedirectToSearchPage,
	})

mainFormPresenter.on('form-submit', handleFormSubmit)
headerFormPresenter.on('form-submit', handleFormSubmit)

const contentHotelsRootElement = document.querySelector('.js-content-hotels')
const selectionCriteriaView = new SelectionCriteriaView({
	parentElement: contentHotelsRootElement,
	topOffset: headerElement.clientHeight,
})
selectionCriteriaView.on('show', () => stickyHeader.lock())
selectionCriteriaView.on('hide', () => stickyHeader.unlock())
